import React from 'react';

interface HostedInvoiceDialogProps {
    hostedInvoiceData: {
        url: string;
        subscriptionId: string;
    };
}

const HostedInvoiceDialog: React.FC<HostedInvoiceDialogProps> = ({ hostedInvoiceData }) => {
    return (
        <div className='min-h-screen bg-custom-background flex items-center justify-center px-4 sm:px-6 lg:px-8'>
            <div className='max-w-md w-full mx-auto p-8 bg-white rounded-2xl shadow-xl border border-gray-100 text-center'>
                <div className='mb-6'>
                    <div className='w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4'>
                        <svg
                            className='w-8 h-8 text-amber-600'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                        >
                            <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth='2'
                                d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z'
                            ></path>
                        </svg>
                    </div>
                </div>
                <h2 className='text-2xl font-bold text-gray-900 mb-2'>Complete Your Payment</h2>
                <p className='text-gray-600 mb-6'>
                    Please complete your payment using the secure Stripe invoice link below. Then
                    check subscription status to verify your payment.
                </p>

                <div className='mb-6'>
                    <a
                        href={hostedInvoiceData.url}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='inline-flex items-center justify-center w-full bg-gradient-to-r from-blue-600 to-purple-600 !text-black py-3 px-4 rounded-lg hover:from-blue-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 font-medium'
                    >
                        <svg
                            className='w-5 h-5 mr-2'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                        >
                            <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth='2'
                                d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'
                            ></path>
                        </svg>
                        Complete Payment on Stripe
                    </a>
                </div>

                <div className='mt-6 text-sm text-gray-500'>
                    <p className='mb-2'>
                        <strong>What happens next?</strong>
                    </p>
                    <ol className='text-left space-y-1'>
                        <li>1. Click the payment link above</li>
                        <li>2. Complete payment on Stripe</li>
                        <li>3. Wait for an email from Mindful Games</li>
                    </ol>
                </div>

                <div className='mt-6 pt-4 border-t border-gray-200'>
                    <a
                        href='/login'
                        className='inline-flex items-center text-sm text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200'
                    >
                        <svg
                            className='w-4 h-4 mr-1'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                        >
                            <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth='2'
                                d='M10 19l-7-7m0 0l7-7m-7 7h18'
                            ></path>
                        </svg>
                        Back to Login
                    </a>
                </div>
            </div>
        </div>
    );
};

export default HostedInvoiceDialog;
